import axios from 'axios';
import { Component } from "react";
import { baseUrl, config } from './index.js';

export default class SchemeService extends Component {
  static createScheme = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/create_scheme?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAllSchemes = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_all_schemes?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      config.params = data;
      config.data = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static updateStatus = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/approve_scheme?lang=' + localStorage.getItem('localLang');
      config.method = 'post';
      config.params = '';
      config.data = data;
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
      return response ? response : [];
    }
  };

  static deletePost = async (payload) => {
    try {
      config.url = baseUrl + '/wp/v2/agp_delete_post';
      config.method = 'post';
      config.data = payload;
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH DELETE ERROR`, response);
      return response ? response : [];
    }
  };

}
